export default __webpack_public_path__ + "static/media/Thief's Mask of the Deceiver.7957bb1d.jpg";